import React, { ComponentProps } from 'react';

import { BaseInputField, BaseInputFieldProps } from './BaseInputField';

type Props = BaseInputFieldProps &
  Pick<ComponentProps<'input'>, 'min' | 'max' | 'step'>;

export const NumberField = (props: Props) => {
  return <BaseInputField type="number" {...props} />;
};
